'use client';

import { ChangeEvent, forwardRef } from 'react';

import { FormControl } from '../FormControl';
import { FormHelperText } from '../FormHelperText';

import { ErrorMessage, StyledTextField, TextFieldContainer } from './styled';
import { TextFieldProps } from './types';

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    const {
      label,
      className,
      onChange,
      helperText,
      error,
      tooltipText,
      errorMessage,
      ...rest
    } = props;

    const handleTextFieldChange = (
      event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      if (onChange) {
        onChange(event.target.value);
      }
    };

    return (
      <TextFieldContainer>
        <FormControl fullWidth className={className}>
          {Boolean(label) && (
            <FormHelperText
              type="label"
              component="div"
              tooltipText={tooltipText}
            >
              {label}
            </FormHelperText>
          )}
          <StyledTextField
            variant="outlined"
            onChange={handleTextFieldChange}
            error={error}
            ref={ref}
            {...rest}
          />
          {Boolean(helperText) && (
            <FormHelperText error={error} type="helperText">
              {helperText}
            </FormHelperText>
          )}
          {Boolean(errorMessage) && (
            <ErrorMessage variant="label3" component="div">
              {errorMessage}
            </ErrorMessage>
          )}
        </FormControl>
      </TextFieldContainer>
    );
  },
);
